// Memorial entry for Dror Or
import drorOrPortrait from '../../../images/dror-or.jpg';

export const drorOrMemorial = {
  id: 38,
  name: 'Dror Or',
  images: {
    portrait: drorOrPortrait
  },
  info: `
"He had this inner peace ever since he was a child. His glance, his embrace – there was always a feeling with him that everything would be OK." - His mother Dorit

# Dror Or

![Dror Or](${drorOrPortrait})
*Dror Or, 48, cheesemaker, yoga teacher, man of peace*

## Golden Hands

Dror Or was Be'eri's cheesemaker - the man with the "golden touch" who spent 15 years crafting award-winning gruyere, manchego, and blue cheeses at the kibbutz dairy. He graduated with honors from culinary school, worked at iconic Tel Aviv restaurants, then found his calling in artisanal cheese.

He also practiced yoga for 20 years, becoming a certified instructor. His father said yoga was essential to who Dror was - contributing to his remarkable inner peace.

He married Yonat, raised three children - Yahli, Noam, and Alma - and lived a life his family described as "freedom and light, of spirit and creativity."

## October 7, 2023

When Hamas attacked, Dror, Yonat, and their two younger children barricaded in the safe room. When terrorists set the house on fire, the parents made a decision that saved their children: they told Noam and Alma to jump out the window and run.

The children were later captured and taken to Gaza, but released after 50 days.

Yonat was murdered. Dror was captured separately.

He was killed on October 7, 2023.

## The Last of Be'eri

For 782 days, Dror's body remained in Gaza. His remains were finally returned on November 25, 2025 - exactly two years to the day after his children came home.

His father noted: "Dror returned last night... Exactly two years ago, at the same hour, his two children came back."

He was the last hostage from Kibbutz Be'eri, and the last from the Gaza border region.

At his funeral, President Herzog said: "Finally, after over two years of agony and pain, Dror Or — the final abducted fatality of the kibbutz — is laid to rest in the soil of the kibbutz he so deeply loved."

He was buried alongside his wife Yonat at Kibbutz Be'eri.

His colleague at the dairy: "He had a golden touch; he knew all kinds of things."

*A man of peace, creativity and love. May his memory be a blessing.*

[Read more](https://www.timesofisrael.com/dror-or-48-cheesemaker-yoga-instructor-and-father-of-3/)
`
};
